'use client';

import { createContext, useCallback, useMemo, useState } from 'react';

interface AskModalContextType {
	isOpen: boolean;
	onOpen: () => void;
	onClose: () => void;
}

export const AskModalContext = createContext<AskModalContextType | undefined>(
	undefined,
);

export function AskModalProvider({
	children,
}: { readonly children: React.ReactNode }) {
	const [isOpen, setIsOpen] = useState(false);

	const onOpen = useCallback(() => setIsOpen(true), []);
	const onClose = useCallback(() => setIsOpen(false), []);

	const value = useMemo(
		() => ({
			isOpen,
			onOpen,
			onClose,
		}),
		[isOpen, onOpen, onClose],
	);

	return (
		<AskModalContext.Provider value={value}>
			{children}
		</AskModalContext.Provider>
	);
}
